export const STRINGS = {
  SEARCH_PLACEHOLDER: "Search",
  EMPTY: "",
  TOOLTIP_PROVIDER_LINK: "View Provider Details",
  TOOLTIP_CLIENT_LINK: "Go to Case Detail",
  DATE_START_PLACEHOLDER: "Beginning",
};
